module.exports = __webpack_public_path__ + "static/media/live-bacarrat.19544217.svg";